import * as $ from 'jquery';

function exportDefaultViewModel(id, inputfields) {
    var vm = {};
    for (var inputfieldIndex in inputfields) {
        var inputfield = inputfields[inputfieldIndex];
        var classname = id + "_" + inputfield;
        vm[inputfield] = $("." + classname).val()
    }
    return vm;
}

function importDefaultViewModel(id, inputfields, vm) {
    for (var inputfieldIndex in inputfields) {
        var inputfield = inputfields[inputfieldIndex];
        var classname = id + "_" + inputfield;
        $("." + classname).val(vm[inputfield]);
    }
}

function getDtFrame(id) {
    return $("#sid-dt-frame_" + id);
}

function getRtFrame(id) {
    return $("#component_id_" + id);
}

function arrayRemove(arr, value) {
    return arr.filter(function (ele) {
        return ele != value;
    });
}

function mdToHtml(md) {
    var res = "";
    if (md) {
        var interrim = md.split("**");
        if (interrim.length == 1)
            return md;
        var em = false;
        for (var i in interrim) {
            if (em) {
                res += interrim[i] + "</strong>";
                em = false;
            } else {
                res += interrim[i] + "<strong>";
                em = true;
            }
        }
    }
    return res;
}

function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

function getButtonClasses() {
    return "btn btn-white border text-uppercase fw-bold fs-button-small m-2 p-2 ms-0 w-100 btn-hover";
}

// Looks up a UI text passed in from Angular (params.uiTexts) and fills in {{placeholders}}
function uiText(context, key, fallback, replacements) {
    let text = context?.params?.uiTexts?.[key] || fallback;
    for (let name in replacements ?? {})
        text = text.replaceAll(`{{${name}}}`, replacements[name]);
    return text;
}

export default {
    getDtFrame,
    getRtFrame,
    exportDefaultViewModel,
    importDefaultViewModel,
    arrayRemove,
    mdToHtml,
    round,
    getButtonClasses,
    uiText
}